<template>
  <section class="cont-inner">
    <SearchTagBox />

    <SearchPopularSectionList
      v-if="hasPopularCellList"
      :popular-section="popularSection"
    />
    <section
      v-else
      class="search-empty"
    >
      <p class="dsc">잠시 후 시도해주세요</p>
    </section>
  </section>
</template>

<script>
import SearchTagBox from '@/components/search/view/SearchTagBox'
import SearchPopularSectionList from '@/components/band/SearchPopularSectionList'

export default {
  name: 'SearchPopular',
  components: {
    SearchTagBox,
    SearchPopularSectionList
  },
  props: {
    popularSection: {
      type: Array,
      default: null
    }
  },
  computed: {
    hasPopularCellList () {
      return this.popularSection.length > 0
    }
  }
}
</script>
